import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { isCollaborator } from 'project/utils';
import { ELITE_TIPPED_SPOTS_TEXT } from 'project/constants';

export default class PackageTipped extends Component {
  componentDidMount() {
    const { fetchPackageTipped, project } = this.props;

    if (this.shouldShow()) {
      fetchPackageTipped(project.id);
    }
  }

  shouldShow() {
    const { project, user, isEliteParticipant } = this.props;

    return (
      project.elite_only &&
      project.package_tips.length > 0 &&
      (user.is_staff || isEliteParticipant || user.id === project.client || isCollaborator(project))
    );
  }

  renderContent() {
    const { project, user, packageTipped } = this.props;
    const allTips = project.package_tips;
    const prices = allTips.reduce((acc, t, i) => {
      const value = `$${t.feature.value}`;

      if (i === allTips.length - 1) {
        return `${acc}${value}`;
      }
      if (i === allTips.length - 2) {
        return `${acc}${value} and `;
      }

      return `${acc}${value}, `;
    }, '');
    const tipWon = packageTipped.find(tipped => tipped.id === user.id);
    const awardValue = project.award_rules[0].feature.value;

    return (
      <div>
        This Elite project includes one ${awardValue} award and guaranteed tips
        of { prices } that<br className="show-for-large" /> will be paid
        to each of the { ELITE_TIPPED_SPOTS_TEXT } non-winning
        participants when the project is completed.

        { !!tipWon &&
        <div>
          <h5>
            You didn't win this project, but got a ${tipWon.amount} tip. Well done!
          </h5>
        </div> }

        { (user.is_staff || user.id === project.client || isCollaborator(project)) &&
        <div>
          <h5>The following designers got a guaranteed tip:</h5>
          { packageTipped.map(tipped => (
          <div key={tipped.id}>
            ${tipped.amount} tip: {' '}
            <Link to={`/users/${tipped.username}/`} target="_blank">{ tipped.username }</Link>
          </div>
          )) }
        </div> }
      </div>
    );
  }

  render() {
    const { packageTipped } = this.props;

    if (!this.shouldShow() || !packageTipped) {
      return null;
    }

    return (
      <div className="callout warning package-tipped">
        <div className="row">
          <div className="columns small-16">
            { this.renderContent() }
          </div>
        </div>
      </div>
    );
  }
}

PackageTipped.propTypes = {
  project: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  packageTipped: PropTypes.array,
  isEliteParticipant: PropTypes.bool,
  fetchPackageTipped: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./entries/components/package_tipped.jsx